// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #f7f8fa;
  --surface: #ffffff;
  --border: #e4e7ec;
  --text: #1a1d21;
  --text-muted: #5c6570;
  --accent: #1a6b5c;
  --accent-hover: #145548;
  --accent-soft: #e8f4f1;
  --danger: #b42318;
  --danger-soft: #fef3f2;
  --warning-soft: #fffaeb;
  --warning-text: #854d0e;
  --radius: 10px;
  --shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: var(--text);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;
}

.app {
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1.5rem 4rem;
}

.header {
  margin-bottom: 2.5rem;
}

.header h1 {
  margin: 0 0 0.75rem;
  font-size: 1.75rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--text);
}

.header-home {
  color: inherit;
  text-decoration: none;
}

.header p {
  margin: 0;
  max-width: none;
  color: var(--text-muted);
  font-size: 0.9375rem;
  column-count: 2;
  column-gap: 2rem;
  text-align: justify;
  hyphens: auto;
}

.dwca-term {
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 0.8125rem;
  color: var(--accent);
  background: var(--accent-soft);
  padding: 0.1em 0.4em;
  border-radius: 4px;
}

a {
  color: var(--accent);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.example-link {
  color: var(--accent);
  font-weight: 500;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.example-link:hover {
  color: var(--accent-hover);
}

.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 1.75rem;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.25rem;
}

.form-group:last-of-type {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text);
}

.form-input,
.form-select {
  display: block;
  width: 100%;
  max-width: 480px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9375rem;
  font-family: inherit;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(26, 107, 92, 0.12);
}

.form-input:disabled,
.form-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.form-input[type='file'] {
  padding: 0.45rem 0.75rem;
  font-size: 0.875rem;
}

.form-input-sm,
.form-select-sm {
  max-width: none;
  padding: 0.35rem 0.5rem;
  font-size: 0.8125rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.55rem 1.1rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.4;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.btn-primary {
  background: var(--accent);
  color: #fff;
}

.btn-primary:hover:not(:disabled) {
  background: var(--accent-hover);
}

.btn-outline {
  background: var(--surface);
  color: var(--text);
  border-color: var(--border);
}

.btn-outline:hover:not(:disabled) {
  background: var(--bg);
  border-color: #c8cdd4;
}

.btn-outline-danger {
  color: var(--danger);
  border-color: #fecdca;
}

.btn-outline-danger:hover:not(:disabled) {
  background: var(--danger-soft);
  border-color: #fda29b;
}

.btn-sm {
  padding: 0.35rem 0.75rem;
  font-size: 0.8125rem;
}

.btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1.25rem;
  color: var(--text-muted);
  font-size: 0.875rem;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid var(--border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.alert {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  margin-top: 1.25rem;
}

.alert-danger {
  background: var(--danger-soft);
  color: var(--danger);
  border: 1px solid #fecdca;
}

.alert-warning {
  background: var(--warning-soft);
  color: var(--warning-text);
  border: 1px solid #fde68a;
}

.results {
  margin-top: 2.5rem;
}

.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.results-header h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.score-dotplot {
  position: relative;
  margin-bottom: 1.25rem;
  padding: 0.75rem 0.75rem 0.25rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
  box-shadow: var(--shadow);
}

.score-dotplot svg {
  display: block;
  width: 100%;
  height: auto;
}

.score-dotplot-grid {
  stroke: var(--border);
  stroke-width: 1;
  stroke-dasharray: 2 3;
}

.score-dotplot-axis {
  stroke: #98a2b3;
  stroke-width: 1;
}

.score-dotplot-tick {
  fill: var(--text-muted);
  font-size: 8px;
}

.score-dotplot-label {
  fill: var(--text-muted);
  font-size: 9px;
  font-weight: 500;
}

.score-dotplot-point {
  fill-opacity: 0.75;
  stroke-opacity: 0.95;
  stroke-width: 1;
  cursor: default;
}

.score-dotplot-point.is-active {
  fill-opacity: 1;
  stroke-width: 1.5;
}

.score-dotplot-tooltip {
  position: absolute;
  z-index: 5;
  max-width: 260px;
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--surface);
  box-shadow: var(--shadow);
  pointer-events: none;
}

.score-dotplot-tooltip-name {
  font-size: 0.8125rem;
  font-weight: 600;
  font-style: italic;
  color: var(--text);
}

.score-dotplot-tooltip-meta {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
  box-shadow: var(--shadow);
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

thead {
  background: var(--surface);
  border-bottom: 1px solid var(--border);
}

th {
  padding: 0.65rem 0.85rem;
  text-align: left;
  font-weight: 500;
  color: var(--text-muted);
  white-space: nowrap;
}

td {
  padding: 0.6rem 0.85rem;
  border-top: 1px solid var(--border);
  vertical-align: middle;
}

td.species {
  font-weight: 500;
  max-width: 200px;
  padding-left: 0.4rem;
}

.species-toggle {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-weight: 500;
  color: var(--accent);
  text-align: left;
  cursor: pointer;
}

.species-toggle:hover {
  text-decoration: underline;
}

.badge {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  min-width: 3rem;
  text-align: center;
}

.empty-cell {
  color: #a0a8b0;
}

.col-toggle {
  width: 1.75rem;
  padding: 0.6rem 0.25rem 0.6rem 0.85rem;
  vertical-align: middle;
  line-height: 1.2;
}

.row-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  color: var(--text-muted);
  cursor: pointer;
  font: inherit;
  line-height: 0;
  vertical-align: middle;
  transition: color 0.15s;
}

.row-toggle svg {
  width: 1.25rem;
  height: 1.25rem;
  display: block;
  transform: translateY(0.5px);
}

.row-toggle:hover {
  color: var(--text);
}

.row-toggle-open {
  color: var(--accent);
}

.row-toggle-globe,
.row-toggle-globe:hover,
.row-toggle-globe:focus {
  color: #000;
}

.expand-sequence {
  padding: 0.85rem 1rem 0.65rem;
  border-bottom: 1px solid var(--border);
  background: var(--surface, #fff);
}

.expand-sequence-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.expand-sequence-title {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.sequence-blast-btn {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  background: var(--accent);
  color: #fff;
  font: inherit;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  text-decoration: none;
  line-height: 1.2;
  transition: background-color 0.15s;
}

.sequence-blast-btn:hover {
  background: var(--accent-hover);
  color: #fff;
  text-decoration: none;
}

.sequence-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  padding: 0.2rem 0.35rem;
  border: none;
  border-radius: 4px;
  background: none;
  color: var(--text-muted);
  cursor: pointer;
  line-height: 1;
  flex-shrink: 0;
  font: inherit;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  text-decoration: none;
  transition: color 0.15s, background-color 0.15s;
}

.sequence-action-btn svg {
  width: 1rem;
  height: 1rem;
}

.sequence-copy-label {
  line-height: 1;
}

.sequence-action-btn:hover {
  color: var(--text);
  background: rgba(16, 24, 40, 0.05);
  text-decoration: none;
}

.sequence-action-btn-done,
.sequence-action-btn-done:hover {
  color: var(--accent);
  background: rgba(26, 107, 92, 0.1);
}

.expand-sequence-body {
  margin: 0;
  max-height: 7.5rem;
  overflow: auto;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-all;
  color: var(--text);
}

.row-expanded {
  background: rgba(26, 107, 92, 0.04);
}

.expand-row td {
  padding: 0;
  border-top: none;
  background: var(--bg);
}

.expand-row:hover {
  background: var(--bg);
}

.density-map-panel {
  padding: 1rem;
}

.density-map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
  font-size: 0.8125rem;
  color: var(--text-muted);
}

.density-map-title {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.density-map-links {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
}

.density-map-links a {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
}

.density-map-links svg {
  width: 0.75rem;
  height: 0.75rem;
  opacity: 0.75;
}

.density-map-copy-prompt {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: var(--accent);
  font: inherit;
  cursor: pointer;
  text-decoration: none;
}

.density-map-copy-prompt:hover {
  text-decoration: underline;
}

.density-map-copy-prompt-done,
.density-map-copy-prompt-done:hover {
  text-decoration: none;
}

.density-map-header-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.85rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.density-map-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  color: var(--text-muted);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.density-map-toggle input {
  margin: 0;
  accent-color: var(--accent);
}

.density-map-legend {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.75rem;
}

.density-map-legend-bar {
  display: inline-block;
  width: 80px;
  height: 8px;
  border-radius: 4px;
  background: linear-gradient(
    to right,
    rgba(255, 245, 240, 0.15) 0%,
    #fde6d8 25%,
    #f8cdb8 45%,
    #efab8a 65%,
    #e08b6d 85%,
    #c96f55 100%
  );
  border: 1px solid var(--border);
}

.density-map-legend-bar-suitability {
  background: linear-gradient(
    to right,
    rgba(240, 249, 247, 0.15) 0%,
    #c8ebe3 25%,
    #8fd4c4 45%,
    #4fb39c 65%,
    #2a8f7a 85%,
    #1a6b5c 100%
  );
}

.density-map-legend-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #c0392b;
  opacity: 0.75;
}

.congener-note {
  margin: 0.55rem 0 0;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.congener-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem 0.9rem;
  margin: 0.45rem 0 0;
  padding: 0;
  list-style: none;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.congener-legend li {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.congener-legend em {
  font-style: italic;
}

.congener-swatch {
  display: inline-block;
  width: 18px;
  height: 4px;
  border-radius: 2px;
}

.congener-popover {
  position: fixed;
  z-index: 1000;
  max-width: 260px;
  padding: 0.4rem 0.6rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  pointer-events: none;
}

.congener-popover-list {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.congener-popover-list li {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.75rem;
  color: var(--text);
}

.congener-popover-list em {
  font-style: italic;
}

.congener-popover-swatch {
  flex: none;
  width: 9px;
  height: 9px;
  border-radius: 50%;
}

.density-map {
  width: 100%;
  height: 360px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border);
}

.density-map-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 2rem 1rem;
  color: var(--text-muted);
  font-size: 0.875rem;
}

.density-map-error {
  padding: 1rem;
  color: var(--danger);
  font-size: 0.875rem;
}

.coord-popover-trigger {
  padding: 0;
  border: none;
  background: none;
  color: var(--accent);
  font: inherit;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  text-align: left;
  text-decoration: underline;
  text-decoration-color: rgba(26, 107, 92, 0.35);
  text-underline-offset: 2px;
}

.coord-popover-trigger:hover {
  color: var(--accent-hover, #145549);
}

.coord-popover-panel {
  position: fixed;
  z-index: 1000;
  width: 280px;
  padding: 0.5rem;
  background: var(--surface, #fff);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.location-mini-map {
  width: 100%;
  height: 180px;
  border-radius: 6px;
  overflow: hidden;
}

tbody tr:not(.expand-row):hover {
  background: rgba(26, 107, 92, 0.03);
}

@media (max-width: 640px) {
  .app {
    padding: 2rem 1rem 3rem;
  }

  .header h1 {
    font-size: 1.5rem;
  }

  .header p {
    column-count: 1;
    text-align: left;
  }

  .card {
    padding: 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,uGAAuG;EACvG,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gEAAgE;EAChE,oBAAoB;EACpB,oBAAoB;EACpB,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,6EAA6E;EAC7E,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB;;;;;;;;GAQC;EACD,+BAA+B;AACjC;;AAEA;EACE;;;;;;;;GAQC;AACH;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[":root {\n  --bg: #f7f8fa;\n  --surface: #ffffff;\n  --border: #e4e7ec;\n  --text: #1a1d21;\n  --text-muted: #5c6570;\n  --accent: #1a6b5c;\n  --accent-hover: #145548;\n  --accent-soft: #e8f4f1;\n  --danger: #b42318;\n  --danger-soft: #fef3f2;\n  --warning-soft: #fffaeb;\n  --warning-text: #854d0e;\n  --radius: 10px;\n  --shadow: 0 1px 3px rgba(16, 24, 40, 0.06);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--text);\n  background: var(--bg);\n  -webkit-font-smoothing: antialiased;\n}\n\n.app {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 3rem 1.5rem 4rem;\n}\n\n.header {\n  margin-bottom: 2.5rem;\n}\n\n.header h1 {\n  margin: 0 0 0.75rem;\n  font-size: 1.75rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--text);\n}\n\n.header-home {\n  color: inherit;\n  text-decoration: none;\n}\n\n.header p {\n  margin: 0;\n  max-width: none;\n  color: var(--text-muted);\n  font-size: 0.9375rem;\n  column-count: 2;\n  column-gap: 2rem;\n  text-align: justify;\n  hyphens: auto;\n}\n\n.dwca-term {\n  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;\n  font-size: 0.8125rem;\n  color: var(--accent);\n  background: var(--accent-soft);\n  padding: 0.1em 0.4em;\n  border-radius: 4px;\n}\n\na {\n  color: var(--accent);\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.example-link {\n  color: var(--accent);\n  font-weight: 500;\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.example-link:hover {\n  color: var(--accent-hover);\n}\n\n.card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  padding: 1.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.form-group {\n  margin-bottom: 1.25rem;\n}\n\n.form-group:last-of-type {\n  margin-bottom: 1.5rem;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.form-input,\n.form-select {\n  display: block;\n  width: 100%;\n  max-width: 480px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9375rem;\n  font-family: inherit;\n  color: var(--text);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.form-input:focus,\n.form-select:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(26, 107, 92, 0.12);\n}\n\n.form-input:disabled,\n.form-select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.form-input[type='file'] {\n  padding: 0.45rem 0.75rem;\n  font-size: 0.875rem;\n}\n\n.form-input-sm,\n.form-select-sm {\n  max-width: none;\n  padding: 0.35rem 0.5rem;\n  font-size: 0.8125rem;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  padding: 0.55rem 1.1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  line-height: 1.4;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: var(--accent);\n  color: #fff;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--accent-hover);\n}\n\n.btn-outline {\n  background: var(--surface);\n  color: var(--text);\n  border-color: var(--border);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: var(--bg);\n  border-color: #c8cdd4;\n}\n\n.btn-outline-danger {\n  color: var(--danger);\n  border-color: #fecdca;\n}\n\n.btn-outline-danger:hover:not(:disabled) {\n  background: var(--danger-soft);\n  border-color: #fda29b;\n}\n\n.btn-sm {\n  padding: 0.35rem 0.75rem;\n  font-size: 0.8125rem;\n}\n\n.btn-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n  color: var(--text-muted);\n  font-size: 0.875rem;\n}\n\n.spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--border);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.alert {\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  margin-top: 1.25rem;\n}\n\n.alert-danger {\n  background: var(--danger-soft);\n  color: var(--danger);\n  border: 1px solid #fecdca;\n}\n\n.alert-warning {\n  background: var(--warning-soft);\n  color: var(--warning-text);\n  border: 1px solid #fde68a;\n}\n\n.results {\n  margin-top: 2.5rem;\n}\n\n.results-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.results-header h2 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n}\n\n.score-dotplot {\n  position: relative;\n  margin-bottom: 1.25rem;\n  padding: 0.75rem 0.75rem 0.25rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--surface);\n  box-shadow: var(--shadow);\n}\n\n.score-dotplot svg {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.score-dotplot-grid {\n  stroke: var(--border);\n  stroke-width: 1;\n  stroke-dasharray: 2 3;\n}\n\n.score-dotplot-axis {\n  stroke: #98a2b3;\n  stroke-width: 1;\n}\n\n.score-dotplot-tick {\n  fill: var(--text-muted);\n  font-size: 8px;\n}\n\n.score-dotplot-label {\n  fill: var(--text-muted);\n  font-size: 9px;\n  font-weight: 500;\n}\n\n.score-dotplot-point {\n  fill-opacity: 0.75;\n  stroke-opacity: 0.95;\n  stroke-width: 1;\n  cursor: default;\n}\n\n.score-dotplot-point.is-active {\n  fill-opacity: 1;\n  stroke-width: 1.5;\n}\n\n.score-dotplot-tooltip {\n  position: absolute;\n  z-index: 5;\n  max-width: 260px;\n  padding: 0.45rem 0.6rem;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: var(--surface);\n  box-shadow: var(--shadow);\n  pointer-events: none;\n}\n\n.score-dotplot-tooltip-name {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  font-style: italic;\n  color: var(--text);\n}\n\n.score-dotplot-tooltip-meta {\n  margin-top: 0.15rem;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--surface);\n  box-shadow: var(--shadow);\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n}\n\nthead {\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n}\n\nth {\n  padding: 0.65rem 0.85rem;\n  text-align: left;\n  font-weight: 500;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\ntd {\n  padding: 0.6rem 0.85rem;\n  border-top: 1px solid var(--border);\n  vertical-align: middle;\n}\n\ntd.species {\n  font-weight: 500;\n  max-width: 200px;\n  padding-left: 0.4rem;\n}\n\n.species-toggle {\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n  font-weight: 500;\n  color: var(--accent);\n  text-align: left;\n  cursor: pointer;\n}\n\n.species-toggle:hover {\n  text-decoration: underline;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.2rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  min-width: 3rem;\n  text-align: center;\n}\n\n.empty-cell {\n  color: #a0a8b0;\n}\n\n.col-toggle {\n  width: 1.75rem;\n  padding: 0.6rem 0.25rem 0.6rem 0.85rem;\n  vertical-align: middle;\n  line-height: 1.2;\n}\n\n.row-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  font: inherit;\n  line-height: 0;\n  vertical-align: middle;\n  transition: color 0.15s;\n}\n\n.row-toggle svg {\n  width: 1.25rem;\n  height: 1.25rem;\n  display: block;\n  transform: translateY(0.5px);\n}\n\n.row-toggle:hover {\n  color: var(--text);\n}\n\n.row-toggle-open {\n  color: var(--accent);\n}\n\n.row-toggle-globe,\n.row-toggle-globe:hover,\n.row-toggle-globe:focus {\n  color: #000;\n}\n\n.expand-sequence {\n  padding: 0.85rem 1rem 0.65rem;\n  border-bottom: 1px solid var(--border);\n  background: var(--surface, #fff);\n}\n\n.expand-sequence-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.4rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.expand-sequence-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.sequence-blast-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  background: var(--accent);\n  color: #fff;\n  font: inherit;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  text-decoration: none;\n  line-height: 1.2;\n  transition: background-color 0.15s;\n}\n\n.sequence-blast-btn:hover {\n  background: var(--accent-hover);\n  color: #fff;\n  text-decoration: none;\n}\n\n.sequence-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  padding: 0.2rem 0.35rem;\n  border: none;\n  border-radius: 4px;\n  background: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  line-height: 1;\n  flex-shrink: 0;\n  font: inherit;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  text-decoration: none;\n  transition: color 0.15s, background-color 0.15s;\n}\n\n.sequence-action-btn svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.sequence-copy-label {\n  line-height: 1;\n}\n\n.sequence-action-btn:hover {\n  color: var(--text);\n  background: rgba(16, 24, 40, 0.05);\n  text-decoration: none;\n}\n\n.sequence-action-btn-done,\n.sequence-action-btn-done:hover {\n  color: var(--accent);\n  background: rgba(26, 107, 92, 0.1);\n}\n\n.expand-sequence-body {\n  margin: 0;\n  max-height: 7.5rem;\n  overflow: auto;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  word-break: break-all;\n  color: var(--text);\n}\n\n.row-expanded {\n  background: rgba(26, 107, 92, 0.04);\n}\n\n.expand-row td {\n  padding: 0;\n  border-top: none;\n  background: var(--bg);\n}\n\n.expand-row:hover {\n  background: var(--bg);\n}\n\n.density-map-panel {\n  padding: 1rem;\n}\n\n.density-map-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n  font-size: 0.8125rem;\n  color: var(--text-muted);\n}\n\n.density-map-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n  flex-wrap: wrap;\n}\n\n.density-map-links {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.density-map-links a {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n}\n\n.density-map-links svg {\n  width: 0.75rem;\n  height: 0.75rem;\n  opacity: 0.75;\n}\n\n.density-map-copy-prompt {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--accent);\n  font: inherit;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.density-map-copy-prompt:hover {\n  text-decoration: underline;\n}\n\n.density-map-copy-prompt-done,\n.density-map-copy-prompt-done:hover {\n  text-decoration: none;\n}\n\n.density-map-header-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.density-map-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  cursor: pointer;\n  user-select: none;\n}\n\n.density-map-toggle input {\n  margin: 0;\n  accent-color: var(--accent);\n}\n\n.density-map-legend {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.75rem;\n}\n\n.density-map-legend-bar {\n  display: inline-block;\n  width: 80px;\n  height: 8px;\n  border-radius: 4px;\n  background: linear-gradient(\n    to right,\n    rgba(255, 245, 240, 0.15) 0%,\n    #fde6d8 25%,\n    #f8cdb8 45%,\n    #efab8a 65%,\n    #e08b6d 85%,\n    #c96f55 100%\n  );\n  border: 1px solid var(--border);\n}\n\n.density-map-legend-bar-suitability {\n  background: linear-gradient(\n    to right,\n    rgba(240, 249, 247, 0.15) 0%,\n    #c8ebe3 25%,\n    #8fd4c4 45%,\n    #4fb39c 65%,\n    #2a8f7a 85%,\n    #1a6b5c 100%\n  );\n}\n\n.density-map-legend-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #c0392b;\n  opacity: 0.75;\n}\n\n.congener-note {\n  margin: 0.55rem 0 0;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.congener-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem 0.9rem;\n  margin: 0.45rem 0 0;\n  padding: 0;\n  list-style: none;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.congener-legend li {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.congener-legend em {\n  font-style: italic;\n}\n\n.congener-swatch {\n  display: inline-block;\n  width: 18px;\n  height: 4px;\n  border-radius: 2px;\n}\n\n.congener-popover {\n  position: fixed;\n  z-index: 1000;\n  max-width: 260px;\n  padding: 0.4rem 0.6rem;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  pointer-events: none;\n}\n\n.congener-popover-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.congener-popover-list li {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.75rem;\n  color: var(--text);\n}\n\n.congener-popover-list em {\n  font-style: italic;\n}\n\n.congener-popover-swatch {\n  flex: none;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n}\n\n.density-map {\n  width: 100%;\n  height: 360px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--border);\n}\n\n.density-map-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 2rem 1rem;\n  color: var(--text-muted);\n  font-size: 0.875rem;\n}\n\n.density-map-error {\n  padding: 1rem;\n  color: var(--danger);\n  font-size: 0.875rem;\n}\n\n.coord-popover-trigger {\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--accent);\n  font: inherit;\n  font-variant-numeric: tabular-nums;\n  cursor: pointer;\n  text-align: left;\n  text-decoration: underline;\n  text-decoration-color: rgba(26, 107, 92, 0.35);\n  text-underline-offset: 2px;\n}\n\n.coord-popover-trigger:hover {\n  color: var(--accent-hover, #145549);\n}\n\n.coord-popover-panel {\n  position: fixed;\n  z-index: 1000;\n  width: 280px;\n  padding: 0.5rem;\n  background: var(--surface, #fff);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.location-mini-map {\n  width: 100%;\n  height: 180px;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\ntbody tr:not(.expand-row):hover {\n  background: rgba(26, 107, 92, 0.03);\n}\n\n@media (max-width: 640px) {\n  .app {\n    padding: 2rem 1rem 3rem;\n  }\n\n  .header h1 {\n    font-size: 1.5rem;\n  }\n\n  .header p {\n    column-count: 1;\n    text-align: left;\n  }\n\n  .card {\n    padding: 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
